import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
import { useActions, useSelector } from "app/utils/hooks";
import { fetchTags, clearTags } from "app/actions/tag";
import { RootState } from "typedefs";
import { TagModel } from "app/models";
import DropdownButton from "app/components/DropdownButton";
import { cls } from "app/utils";
import { useTranslation } from "react-i18next";
import { shallowEqual } from "react-redux";
import { Loading } from "app/components/Wrappers";
import { Spinner } from "app/components/Loading";
import { TagSortOrder } from "../Tags.types";
import NoTags from "app/components/NoResults/NoTags";

interface Props {
  sortOrder?: TagSortOrder;
}

const TagsList = ({ sortOrder = "asc" }: Props) => {
  const { t } = useTranslation();
  const tagActions = useActions({
    fetchTags,
    clearTags,
  });

  const tag = useSelector((state: RootState) => state.tag, shallowEqual);
  const { search } = useLocation();

  useEffect(() => {
    if (tag && tag.data && tag.data.length) {
      tagActions.clearTags();
    }
    return () => {
      tagActions.clearTags();
    };
  }, []);

  useEffect(() => {
    tagActions.fetchTags({ orderBy: "name", order: sortOrder });
  }, [sortOrder]);

  const tags = Array.isArray(tag.data) ? tag.data : null;

  if (!tags || (tag.pending && !tags.length)) {
    return (
      <Loading loadType="spinner" isLoading={true} data-testid="tags_loader" />
    );
  }

  if (!tags.length) {
    return <NoTags />;
  }

  const isRefetching = tag.pending;

  const dropdownData = [
    {
      title: t("Edit Name"),
      destination: "edit",
    },
    {
      title: t("Delete"),
      destination: "delete",
      textDanger: true,
    },
  ];

  return (
    <div className={styles.list_wrapper} aria-busy={isRefetching}>
      <div
        className={cls(styles.container, {
          [styles.container_loading]: isRefetching,
        })}
      >
        {tags.map((tag: TagModel) => {
          return (
            <div key={tag.id} className={styles.tag_wrapper}>
              <div className={styles.tag_title}>
                <i className="ico ico-tags-o" />
                {tag.name && <h2>{tag.name}</h2>}
              </div>
              <DropdownButton
                btnClassName={styles.dropdown_btn}
                btnContent={
                  <i
                    className={cls("ico ico-options", styles.dropdown_wrapper)}
                  />
                }
              >
                <ul className={styles.dropdown_list_wrapper}>
                  {dropdownData.map((item, index) => {
                    return (
                      <li key={index}>
                        <Link
                          to={`/account/tags/${tag.id}/${item.destination}${search}`}
                          className={cls({
                            [styles.danger]: item.textDanger,
                          })}
                        >
                          {item.title}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </DropdownButton>
            </div>
          );
        })}
      </div>
      {isRefetching && (
        <div className={styles.loading_overlay}>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default TagsList;
